import FixedAssetAPI from './_fixedAssetApi.js';
import httpClient from '@/apis/base/httpclient';
class FADecrementAPI extends FixedAssetAPI {
  constructor() {
    super();
  }
  controllerName = 'FaDecrements';

  /**
   * Lấy dữ liệu phòng ban
   * TPNAM 28.12.2022
   */
  async getFaTransferAdjustment(param) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetFaTransferAdjustmentDetail',
      data: param,
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Lấy dữ liệu đánh giá lại bảng Fa
   * TPNAM 09.01.2023
   */
  async getFaAdjustmentFa() {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetFaAdjustmentFa',
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu hao mòn và khấu hao nhỏ hơn ngày hạch toán
   * TPNAM 10.01.2023
   */
  async getDepreciationDevaluation(param) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetDepreciationDevaluation',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu đánh giá lại nhỏ hơn ngày CT ghi giảm
   * TPNAM 07.02.2023
   */
  async getAdjustmentForRefdate(param) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetAdjustmentForRefDate',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu ghi tăng trong sổ nhỏ hơn ngày hạch toán
   * TPNAM 10.01.2023
   */
  async getIncrement(param) {
    let apiUrl = this.getAPIUrl();
    let request = {
      url: apiUrl + '/GetIncrement',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Sinh dữ liệu Rút dụ toán chuyển khoản từ chuyển khoản kho bạc
   * NXCHIEN 17.07.2022
   */
  getDataVoucher(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataVoucher',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new FADecrementAPI();
